module.exports = __webpack_public_path__ + "static/media/GPG601A_F01_RD.2bc7c00c.jpg";